/**
 * Central email routing for automated portal mail.
 * Override in `.env` with VITE_* vars (rebuild required).
 */
export const EMAIL_ADDRESSES = {
  customerService:
    import.meta.env.VITE_CUSTOMER_SERVICE_EMAIL || 'devbob.co@gmail.com',
  portalOpsCc: import.meta.env.VITE_PORTAL_OPS_CC_EMAIL || 'devbob.co@gmail.com',
  techAlerts: import.meta.env.VITE_TECH_ALERT_EMAIL || 'devbob.co@gmail.com',
  tradeshowAccountManager:
    import.meta.env.VITE_TRADESHOW_ACCOUNT_MANAGER_EMAIL || 'devbob.co@gmail.com',
} as const;

export const TRADESHOW_ACCOUNT_MANAGER_NAME = 'Account Manager';
